<template>
    <div class="sheetPage">
        <div class="header">
            <headerNotice routerName="电子面单"></headerNotice>
            <el-row class="printBtn" :gutter="24" style="margin-top:20px;">
                <el-col :span="2">
                    <el-button type="info" @click="back">返回</el-button>
                </el-col>
                <el-col :span="4" :offset="5">
                    <el-button type="primary" id="myPreview3" @click="printSystem">系统打印</el-button>
                </el-col>
                <el-col :span="4" :offset="3">
                    <a
                        class="printDownload"
                        href="/CLodop_Setup_for_Win32NT.exe"
                        download="CLodop_Setup_for_Win32NT.exe"
                    >下载打印插件</a>
                </el-col>
            </el-row>
        </div>
        <div class="printSetting">
            <p style="font-size:24px;margin:20px;">打印配置:</p>
            <p style="margin:10px 40px;">
                1：选择如下打印机：
                <input type="radio" id="Radio1" name="RadioS1" :checked="printMac==1" @click="choosePrint(1)">默认打印机
                <input type="radio" id="Radio2" name="RadioS1" :checked="printMac==2" @click="choosePrint(2)">指定打印机:
                <select  id="PrinterList" size="1"  v-if="printMac==2" v-model="printMacType">
                    <option v-for="(item, index) in printMacNameList" :key="index" :value="index">{{item}}</option>
                </select>
            </p>
            <p style="margin:10px 40px;">
                2：用宽
                <input type="text" size="5"  id="W4"  v-model="pageWidth">(mm)<br/>&nbsp;&nbsp; 高
                <input type="text" size="5"  id="H4"  v-model="pageHeight">(mm)进行
                <el-button type="primary" id="myPreview3" @click="printPre">插件预览打印</el-button>
                <el-button type="primary" id="myPreview3" @click="printNow">插件直接打印</el-button>
            </p>
        </div>
        <script id="scriptTxt" type=text/html >
            // 电子订单页面
            .sheetDom {
                margin: 20px 0px;
                margin-right: 15%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 50px;
                font-family: "微软雅黑" !important;
            }
            .sheetDom /deep/ .sheetList {
                margin-bottom: 170px;
            }
            /deep/ .print_paper.table_first td {
                position: static !important;
            }
        </script>
        <!-- 电子订单页面 -->
        <div class="sheetDom" id="sheetDomBox" v-loading="loading"></div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
import printJS from 'print-js'
let LODOP = getLodop();
export default {
    data() {
        return {
            loading: false,
            sheetDoms: '',
            pageWidth:990,//纸张宽
            pageHeight:1480,//纸张高
            printMac:1,//打印机状态 默认  选择
            printMacNameList:[],//打印机列表
            printMacType:0,//打印机类型
        }
    },
    components: {
        headerNotice
    },
    created(){
        if(localStorage.getItem('defaultElePrintProps')){
            let defaultPrintProps = JSON.parse(localStorage.getItem('defaultElePrintProps'));
            this.pageWidth = defaultPrintProps.pageWidth;
            this.pageHeight = defaultPrintProps.pageHeight;
            this.printMac = defaultPrintProps.printMac;
            this.printMacType = defaultPrintProps.printMacType;
        }
    },
    mounted() {
        this.orderIDArr = sessionStorage.getItem('orderIDArr');
        this.orderIDArr = this.orderIDArr.split(',')
        this.getDatas();
        if(LODOP){
            this.CreatePrinterList();
        }
    },
    methods: {
        //获取数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminIntegralExchange/PrintElectronicOrder",
                data: {
                    orderIDs: this.orderIDArr
                },
                success(res) {
                    let sheetDomBox = document.getElementById('sheetDomBox');
                    let sheetListDiv = ''
                    res.forEach((ele, index) => {
                        sheetListDiv += '<div class="sheetList">' + ele + '</div>'
                    })
                    sheetDomBox.innerHTML = sheetListDiv;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //预览打印
        printPre() {
            let self = this;
            try {
                if (LODOP.VERSION) {
                    let scriptTxt = document.getElementById("scriptTxt").innerHTML;
                    let strFormHtml = '<style>' + scriptTxt + '</style>' + document.getElementById("sheetDomBox").innerHTML;
                    LODOP.PRINT_INIT("电子面单");
                    if(this.printMac==1){
                        LODOP.SET_PRINTER_INDEX(-1);
                    }else {
                        LODOP.SET_PRINTER_INDEX(this.printMacType);//选择打印机
                    }
                    LODOP.SET_PRINT_PAGESIZE(1,Number(this.pageWidth),Number(this.pageHeight),"CreateCustomPage");
                    LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml);//添加打印内容
                    LODOP.SET_PRINT_MODE("POS_BASEON_PAPER",true);
                    LODOP.PREVIEW();
                    let params = {
                        pageWidth:this.pageWidth,
                        pageHeight:this.pageHeight,
                        printMac:this.printMac,
                        printMacType:this.printMacType,
                    }
                    localStorage.setItem('defaultElePrintProps',JSON.stringify(params));
                };
            } catch (err) {
                alert("本机未安装Lodop控件！\n 请先下载安装！");
                window.location.reload();
            }
        },
        //直接打印
        printNow() {
            let self = this;
            try {
                if (LODOP.VERSION) {
                    let scriptTxt = document.getElementById("scriptTxt").innerHTML;
                    let strFormHtml = '<style>' + scriptTxt + '</style>' + document.getElementById("sheetDomBox").innerHTML;
                    LODOP.PRINT_INIT("电子面单");
                    if(this.printMac==1){
                        LODOP.SET_PRINTER_INDEX(-1);
                    }else {
                        LODOP.SET_PRINTER_INDEX(this.printMacType);//选择打印机
                    }
                    LODOP.SET_PRINT_PAGESIZE(1,Number(this.pageWidth),Number(this.pageHeight),"CreateCustomPage");
                    LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml);//添加打印内容
                    LODOP.SET_PRINT_MODE("POS_BASEON_PAPER",true);
                    LODOP.PRINT();
                    let params = {
                        pageWidth:this.pageWidth,
                        pageHeight:this.pageHeight,
                        printMac:this.printMac,
                        printMacType:this.printMacType,
                    }
                    localStorage.setItem('defaultElePrintProps',JSON.stringify(params));
                };
            } catch (err) {
                alert("本机未安装Lodop控件！\n 请先下载安装！");
                window.location.reload();
            }
        },
        choosePrint(val){
            this.printMac = val;
        },
        //创建打印机列表
        CreatePrinterList() {
            let iPrinterCount = LODOP.GET_PRINTER_COUNT();
            this.printMacNameList=[];
            for (var i = 0; i < iPrinterCount; i++) {
                this.printMacNameList.push(LODOP.GET_PRINTER_NAME(i));
            };
        },
        //系统打印
        printSystem() {
            printJS({
                printable: 'sheetDomBox',
                type: 'html',
                // 继承原来的所有样式
                targetStyles: ['*']
            })
        },
        //返回
        back() {
            this.$router.back();
        }
    }
}
</script>

<style lang='scss' scoped>
.sheetPage {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    .header {
        position: relative;
        .printBtn {
            position: absolute;
            top: -10px;
            right: 20%;
        }
        .printDownload {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            background: #fff;
            border: 1px solid #dcdfe6;
            color: #606266;
            -webkit-appearance: none;
            text-align: center;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            margin: 0;
            -webkit-transition: 0.1s;
            transition: 0.1s;
            font-weight: 500;
            padding: 12px 20px;
            font-size: 14px;
            border-radius: 4px;
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
        }
    }
    // 电子订单页面
    .sheetDom {
        margin: 20px 0px;
        margin-right: 15%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        font-family: "微软雅黑" !important;
        /deep/ .sheetList {
            margin-bottom: 170px;
        }
    }
    /deep/ .print_paper.table_first {
        td {
            position: static !important;
        }
    }
}
</style>